










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcAccessControlEventTable from '@access-control/components/tables/access-control-event-table.vue';

@Component({
  name: 'access-control-events',
  components: {
    'bpc-access-control-event-table': BpcAccessControlEventTable,
  },
})
export default class AccessControlEvents extends Vue {}
